// 获取URL的文件后缀
export default function getSuffix(url) {
  return url.replace(/^.+\./, '');
}



// WEBPACK FOOTER //
// ./src/util/get-suffix.js